/********************************************************************************
 * Copyright (C) 2017 Ericsson and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

import { injectable } from 'inversify';
import { Emitter, Event } from '@theia/core/lib/common/event';
import { IBaseTerminalClient, IBaseTerminalExitEvent, IBaseTerminalErrorEvent } from './base-terminal-protocol';

@injectable()
export class TerminalWatcher {

    getTerminalClient(): IBaseTerminalClient {
        const exitEmitter = this.onTerminalExitEmitter;
        const errorEmitter = this.onTerminalErrorEmitter;
        return {
            onTerminalExitChanged(event: IBaseTerminalExitEvent): void {
                exitEmitter.fire(event);
            },
            onTerminalError(event: IBaseTerminalErrorEvent): void {
                errorEmitter.fire(event);
            }
        };
    }

    private onTerminalExitEmitter = new Emitter<IBaseTerminalExitEvent>();
    private onTerminalErrorEmitter = new Emitter<IBaseTerminalErrorEvent>();

    get onTerminalExit(): Event<IBaseTerminalExitEvent> {
        return this.onTerminalExitEmitter.event;
    }

    get onTerminalError(): Event<IBaseTerminalErrorEvent> {
        return this.onTerminalErrorEmitter.event;
    }
}
